export default __webpack_public_path__ + "static/media/sld.7ee819aa.webp";